module.exports = __webpack_public_path__ + "static/media/eBike.4ae3279b.svg";